import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const {addData} = useEntityCrud('PersonType/SetPersonType');
    const navigate = useNavigate();

    const initialValues = {
        title: ''
    };
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title
        };
        addData(postedData).then(({data}) => {
            if(data.status){
                toast.success('نوع پرسنل جدید با موفقیت ایجاد شد');
                return navigate('/personnel-types');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/personnel-types',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد نوع پرسنل جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;